export const EMAIL = 'email';
export const FIRST_NAME = 'firstName';
export const LAST_NAME = 'lastName';
